import { useCallback, useEffect, useState } from 'react';
import EmptyListPlaceholder from "../Common/EmptyListPlaceholder";
import { OneMealService } from '../../services/OneMealService';
import OneMealListForModule from './OneMealListForModule';
import { Box, CircularProgress } from '@mui/material';

interface InputProps {
    houseId: number
}

const oneMealService = new OneMealService();

const getSavedState = (key: string) => {
    try {
        return JSON.parse(sessionStorage.getItem(key) || '{}');
    } catch {
        return {};
    }
};

const OneMealHistoryTab = (props: InputProps) => {
    const storageKey = `oms_history_${props.houseId}`;
    const savedState = getSavedState(storageKey);

    let [subData, setSubData] = useState<any>(null);
    let [isLoading, setIsLoading] = useState<boolean>();
    const [pageSize, setPageSize] = useState(savedState.pageSize ?? 50);
    const [currentPage, setCurrentPage] = useState<number>(savedState.page ?? 0);
    const [clickedId, setClickedId] = useState<number | null>(savedState.clickedId ?? null);

    const refreshData = useCallback(
        (pageNo: number) => {
            setIsLoading(true);
            oneMealService
                .getAllOneMealServiceForHouse(
                    props.houseId,
                    pageSize,
                    pageSize * pageNo,
                    { order: "DESC", field: "date" }
                )
                .then((data) => {
                    // Secondary sort: date DESC, then id DESC (more recent id = more recent on same date)
                    const sorted = [...(data?.data ?? [])].sort((a: any, b: any) => {
                        if (b.date > a.date) return 1;
                        if (b.date < a.date) return -1;
                        return b.id - a.id;
                    });
                    setSubData({ ...data, data: sorted });
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        },
        [props.houseId, pageSize]
    );

    useEffect(() => {
        refreshData(currentPage);
    }, [refreshData, currentPage]);

    return (
        <div>
            {isLoading && !subData && (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                    <CircularProgress />
                </Box>
            )}
            {subData &&
                subData?.data &&
                Array.isArray(subData?.data) &&
                (subData?.data?.length > 0 ? (
                    <OneMealListForModule
                        isLoading={isLoading}
                        count={subData?.count}
                        data={subData?.data}
                        refreshData={(pageNo: number) => {
                            setCurrentPage(pageNo);
                        }}
                        setPageSize={(newPageSize: number) => {
                            setCurrentPage(0);
                            setPageSize(newPageSize);
                        }}
                        pageSize={pageSize}
                        initialPage={currentPage}
                        initialFilterModel={savedState.filterModel}
                        clickedId={clickedId}
                        setClickedId={setClickedId}
                        storageKey={storageKey}
                    />
                ) : (
                    <EmptyListPlaceholder message="No One Meal Service found" />
                ))}
        </div>
    );
};

export default OneMealHistoryTab;
